import { mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

export interface ReportOptions {
  description: string;
  id: number;
  isActive: boolean;
  isAllowDetails: boolean;
  orderNumber: number;
  title: string;
}
export const state = () => ({
  options: [] as ReportOptions[]
})

export const mutations = mutationTree(
  state,
  {
    setState
  }
)

// TODO move all this logic to component level
export const actions = actionTree(
  { state, mutations },
  {
    getOptions({ state, commit }) {
      if (state.options.length) { return Promise.resolve(state.options) }

      return this.$api.cardReport.options()
        .then((res: Axios.AxiosResponse) => {
          const list = res.data.data
            .filter((opt: ReportOptions) => opt.isActive)
            .sort((a: ReportOptions, b: ReportOptions) => a.orderNumber - b.orderNumber)

          commit('setState', {
            stateName: 'options',
            data: list
          })

          return list
        })
    },
    reportScholarship(store, opt) {
      return this.$api.cardReport.reportScholarship(opt)
    }
  }
)
